/** The different endpoint actions available for the Amendment route. */
export enum AmendmentActions {
  /** Retrieve the list of actions on a specified amendment. */
  Actions = 'actions',

  /** Retrieve the list of cosponsors on a specified amendment. */
  Cosponsors = 'cosponsors',

  /** Retrieve the list of amendments to the specified amendment. */
  Amendments = 'amendments'
}
